<template>
  <div class="addVipcard">
    <div class="commodityHead" style="height: 70px">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="goback" href="javascript:;">会员卡</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.query.style == 'create'"
          >添加会员卡</el-breadcrumb-item
        >
        <el-breadcrumb-item v-if="$route.query.style == 'update'"
          >编辑会员卡</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div class="addVip">
      <div class="vipCard">
        <div
          class="changeColor"
          v-if="cardColorArr.length !== 0"
          :style="{
            background: `linear-gradient(to bottom right, ${cardColorArr[cardColor].startValue}, ${cardColorArr[cardColor].endValue})`,
          }"
        ></div>
        <img class="card-bg" src="@/assets/img/vip/pattern.png" alt />
        <img v-if="cardColor == 'blue'" src="@/assets/img/vip/tjhyk.png" alt />
        <div class="name" :style="{ color: textColor }">
          {{ ruleForm2.cardName }}
        </div>
        <div class="welcome">{{ ruleForm2.cardSlogan }}</div>
        <div class="time">有效期：{{ ruleForm2.expireType }}</div>
        <div class="discount">
          <span style="font-size: 30px">{{ ruleForm2.discount }}</span
          >折
        </div>
      </div>
      <div class="addVip-content row alignCenter">
        <div>卡片颜色：</div>
        <div id="pcikColor" class="pcikColor center">
          <el-popover placement="right" width="265" trigger="click" v-model="visible">
            <div class="row">
              <div
                v-for="(item, index) in cardColorArr"
                :key="index"
                class="square"
                @click="
                  (fromColor = item),
                    (cardColor = index),
                    (smallColor = item.endValue),
                    (textColor = item.textColor)
                "
                :style="{ background: item.endValue }"
              ></div>
            </div>
            <div class="small" :style="{ background: smallColor }" slot="reference"></div>
          </el-popover>
        </div>
      </div>
      <div class="addVip-content alignCenter">
        <el-form
          :model="ruleForm2"
          :rules="rules2"
          ref="ruleForm2"
          label-width="125px"
          class="demo-ruleForm"
          hide-required-asterisk
          label-position="left"
        >
          <el-form-item label="会员卡名称：" prop="cardName">
            <el-input
              v-model="ruleForm2.cardName"
              autofocus="true"
              placeholder="请输入会员卡名称"
              class="input1"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员卡标语：" prop="cardSlogan">
            <el-input
              v-model="ruleForm2.cardSlogan"
              placeholder="请输入会员卡标语"
              class="input1"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员卡折扣：" prop="discount">
            <el-input
              type="number"
              v-model.number="ruleForm2.discount"
              placeholder="请正确输入如：8.8"
              class="input2"
            ></el-input>
          </el-form-item>
          <el-form-item label="过期类型：" prop="expireType">
            <el-select
              v-model="ruleForm2.expireType"
              placeholder="永久/按天/按时间"
              class="input2"
            >
              <el-option label="永久" value="永久"></el-option>
              <el-option label="按天" value="按天"></el-option>
              <el-option label="按时间" value="按时间"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm2.expireType == '按天'" label prop="expireDayNum">
            <el-input
              v-model.number="ruleForm2.expireDayNum"
              placeholder="输入天数"
              class="input2"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm2.expireType == '按时间'" label prop="time">
            <el-date-picker
              v-model="ruleForm2.time"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @input="timeChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="联系号码：" prop="servicePhone">
            <el-input
              v-model="ruleForm2.servicePhone"
              placeholder="输入联系号码"
              class="input2"
            ></el-input>
          </el-form-item>
          <template v-if="ruleForm2.quickApplySwitch == 4">
            <div>
              <el-form-item label="会员卡价格：" prop="price">
                <el-input
                  type="number"
                  v-model.number="ruleForm2.price"
                  placeholder="请输入会员卡价格"
                  class="input2"
                ></el-input>
              </el-form-item>
              <el-form-item label="会员卡原价：" prop="originalPrice">
                <el-input
                  type="number"
                  v-model.number="ruleForm2.originalPrice"
                  placeholder="请输入会员卡原价"
                  class="input2"
                ></el-input>
              </el-form-item>
            </div>
          </template>
          <el-form-item
            label="默认会员卡："
            prop="resource"
            v-if="ruleForm2.quickApplySwitch != 4"
          >
            <el-radio-group v-model="ruleForm2.isDefault">
              <el-radio label="开启"></el-radio>
              <el-radio label="关闭" checked></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="使用状态：">
            <el-radio-group v-model="ruleForm2.isEnable">
              <el-radio label="启用" checked></el-radio>
              <el-radio label="停用"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="申请会员">
            <!-- <el-switch v-model="ruleForm2.quickApplySwitch" /> -->
            <el-radio-group
              v-model="ruleForm2.quickApplySwitch"
              :disabled="
                ruleForm2.quickApplySwitch == 4 && $route.query.style == 'update'
              "
            >
              <el-radio :label="0">标准申请</el-radio>
              <el-radio :label="1">快速申请</el-radio>
              <el-radio :label="2">支付即会员</el-radio>
              <el-radio :label="3">需商户审核</el-radio>
              <el-radio
                :label="4"
                :disabled="
                  ruleForm2.quickApplySwitch != 4 && $route.query.style == 'update'
                "
                >付费会员</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="积分功能：" prop="integralSwitch">
            <el-switch v-model="ruleForm2.integralSwitch" />
            <div v-show="ruleForm2.integralSwitch == true">
              <el-select
                v-model="integralValue"
                @change="integralValueChange"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in integralList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="会员等级">
            <el-switch v-model="ruleForm2.highSwitch" />
            <div v-if="ruleForm2.highSwitch == true">
              <el-select
                v-model="memberLevel"
                @change="memberLevelChange"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in memberLevelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div>
                <el-input
                  v-model="ruleForm2.cumulateConsumeCount"
                  placeholder="请输入累计成功消费笔数"
                  class="mt10"
                ></el-input>
                <el-input
                  v-model="ruleForm2.cumulateConsumeMoney"
                  placeholder="请输入累计消费金额"
                  class="mt10"
                ></el-input>
                <el-input
                  v-model="ruleForm2.cumulateScore"
                  placeholder="请输入累计达到积分"
                  class="mt10"
                ></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="使用须知：" prop="useNotice">
            <el-input
              type="textarea"
              v-model="ruleForm2.useNotice"
              placeholder="补充信息以便会员知晓"
              class="input1"
            ></el-input>
          </el-form-item>
          <div class="row alignCenter">
            <el-form-item label="支付后可取" v-if="ruleForm2.quickApplySwitch != 4">
              <el-switch value="123" v-model="ruleForm2.openReceiveAfterPay"></el-switch>
            </el-form-item>
            <el-form-item
              id="customerSwitch"
              label="其他APP可领取"
              style="margin-left: 60px"
              v-if="ruleForm2.quickApplySwitch != 4"
            >
              <el-switch v-model="ruleForm2.openReceiveInYSC"></el-switch>
            </el-form-item>
            <div style="height: 40px; margin-left: 15px; color: red">
              提示：会员卡将同步至其他APP供消费者自助领取，吸引客户到店消费
            </div>
          </div>
          <!-- <div class="row alignCenter">
                <el-form-item label="同步支付宝会员卡">
                  <el-switch value="123" v-model="ruleForm2.isAliCard"></el-switch>
                </el-form-item>
                <el-form-item id="customerSwitch" label="同步微信会员卡" style="margin-left:60px">
                  <el-switch v-model="ruleForm2.isWxCard"></el-switch>
                </el-form-item>
              </div> -->
          <el-form-item>
            <el-button type="primary" class="button" @click="createMemberCard"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { memberCardMessage, createMemberCard, updateMemberCard } from "../api/index";
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        // console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    var checkeDay = (rule, value, callback) => {
      if (this.ruleForm2.expireType !== "永久") {
        if (!value) {
          return callback(new Error("天数不能为空"));
        } else if (typeof value !== "number") {
          return callback(new Error("请输入数字"));
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };
    var checkDiscount = (rule, value, callback) => {
      console.log(value, 1);
      if (value.length > 3 || value.length < 1) {
        console.log(value, 2);
        return callback(new Error("请正确输入如：8.8"));
      } else if (typeof value !== "number") {
        console.log(value, 3, typeof value);
        return callback(new Error("请输入数字"));
      } else if (Number(value) > 10) {
        console.log(value, 4);
        return callback(new Error("请正确输入如：8.8"));
      } else {
        console.log(value, 5);
        return callback();
      }
    };
    var checkOriginalPrice = (rule, value, callback) => {
      if (value <= this.ruleForm2.price) {
        return callback(new Error("原价不能小于等于会员卡价格"));
      } else if (typeof value !== "number") {
        return callback(new Error("请输入数字"));
      } else {
        return callback();
      }
    };
    return {
      cardColorArr: [],
      smallColor: "",
      textColor: "",
      fromColor: "",
      ruleForm2: {
        cardName: "",
        cardSlogan: "",
        discount: "",
        expireType: "",
        servicePhone: "",
        price: "",
        originalPrice: "",
        expireDayNum: "",
        cardBackGroup: "",
        useNotice: "",
        isDefault: "关闭",
        isEnable: "启用",
        openReceiveAfterPay: false,
        openReceiveInYSC: false,
        isAliCard: false,
        isWxCard: false,
        time: "",
        integralSwitch: false,
        quickApplySwitch: 0,
        highSwitch: false,
        cumulateConsumeCount: "",
        cumulateConsumeMoney: "",
        cumulateScore: "",
      },
      rules2: {
        cardName: [
          { required: true, message: "请输入会员卡名称", trigger: "blur" },
          {
            min: 1,
            max: 11,
            message: "长度在 1 到 11 个字符",
            trigger: "blur",
          },
        ],
        cardSlogan: [
          { required: true, message: "请输入会员卡标语", trigger: "blur" },
          { min: 1, max: 9, message: "长度在 1 到 9 个字符", trigger: "blur" },
        ],
        discount: [{ validator: checkDiscount, trigger: "blur" }],
        expireType: [{ required: true, message: "请选择日期", trigger: "blur" }],
        time: [{ required: true, message: "请选择日期", trigger: "blur" }],
        servicePhone: [
          { required: true, message: "请输入联系号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        price: [{ required: true, message: "请输入会员卡价格", trigger: "blur" }],
        originalPrice: [{ validator: checkOriginalPrice, trigger: "blur" }],
        expireDayNum: [{ validator: checkeDay, trigger: "blur" }],
        useNotice: [{ required: true, message: "请输入使用须知", trigger: "change" }],
      },
      visible: false,
      cardColor: 0,
      singleVipNews: {},
      integralValue: "",
      integralList: [
        {
          value: "1",
          label: "消费1元送1个积分",
        },
        {
          value: "10",
          label: "消费1元送10个积分",
        },
        {
          value: "100",
          label: "消费1元送100个积分",
        },
      ],
      memberLevelList: [
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5" },
        { value: "6", label: "6" },
        { value: "7", label: "7" },
        { value: "8", label: "8" },
        { value: "9", label: "9" },
        { value: "10", label: "10" },
      ],
      memberLevel: "",
      isCanEdit: true,
    };
  },
  beforeDestroy() {
    localStorage.removeItem("localStorage");
  },
  created() {
    this.singleVipNews = JSON.parse(localStorage.getItem("singleVipNews") || "{}");
    // console.log(this.singleVipNews, "单个会员信息");
    this.getColorArr();
  },
  watch: {
    "ruleForm2.quickApplySwitch": {
      handler: function (val) {
        if (val == 4) {
          this.ruleForm2.isDefault = "关闭";
          this.ruleForm2.openReceiveAfterPay = false;
        }
      },
    },
  },
  methods: {
    timeChange(val) {
      if (val) {
        console.log(val);
        this.ruleForm2.time = [val[0], val[1]];
        this.$forceUpdate();
      }
    },
    integralValueChange(val) {
      console.log(val, "integralValue");
      this.integralValue = val;
    },
    memberLevelChange(val) {
      this.memberLevel = val;
      if (this.memberLevel == 1) {
        this.ruleForm2.isDefault = true;
      } else {
        this.ruleForm2.isDefault = false;
      }
    },
    goback() {
      this.$router.push("/vip/card");
    },
    getColorArr() {
      memberCardMessage({
        shopMemberCardId: this.singleVipNews.shopMemberCardId || "",
      }).then((res) => {
        this.cardColorArr = res.data.shopMemberCardColors;
        this.smallColor = res.data.shopMemberCardColors[0].startValue;
        this.textColor = res.data.shopMemberCardColors[0].textColor;
        this.fromColor = res.data.shopMemberCardColors[0];
        if (this.$route.query.style == "update") {
          for (let i in res.data.shopMemberCardColors) {
            if (
              res.data.shopMemberCardColors[i].id ==
              res.data.shopMemberCard.shopMemberCardColorId
            ) {
              this.cardColor = i;
              this.smallColor = res.data.shopMemberCardColors[i].endValue;
              this.textColor = res.data.shopMemberCardColors[i].textColor;
            }
          }
          this.ruleForm2 = res.data.shopMemberCard;
          if (this.ruleForm2.quickApplySwitch == 4) {
            this.isCanEdit = false;
          }
          console.log(this.ruleForm2, "单个会员信息1");
          this.ruleForm2.discount = Number(this.ruleForm2.discount) * 10;
          if (this.ruleForm2.isEnable == 1) {
            this.ruleForm2.isEnable = "启用";
          } else {
            this.ruleForm2.isEnable = "停用";
          }
          if (this.ruleForm2.isDefault == 0) {
            this.ruleForm2.isDefault = "关闭";
          } else {
            this.ruleForm2.isDefault = "开启";
          }
          // if (this.ruleForm2.quickApplySwitch == 0) {
          //     this.ruleForm2.quickApplySwitch = false;
          //   } else {
          //     this.ruleForm2.quickApplySwitch = true;
          //   }
          if (this.ruleForm2.openReceiveAfterPay == 0) {
            this.ruleForm2.openReceiveAfterPay = false;
          } else {
            this.ruleForm2.openReceiveAfterPay = true;
          }
          if (this.ruleForm2.openReceiveInYSC == 0) {
            this.ruleForm2.openReceiveInYSC = false;
          } else {
            this.ruleForm2.openReceiveInYSC = true;
          }
          if (this.ruleForm2.isWxCard == 0) {
            this.ruleForm2.isWxCard = false;
          } else {
            this.ruleForm2.isWxCard = true;
          }
          if (this.ruleForm2.isAliCard == 0) {
            this.ruleForm2.isAliCard = false;
          } else {
            this.ruleForm2.isAliCard = true;
          }
          if (this.ruleForm2.expireType == 0) {
            this.ruleForm2.expireType = "永久";
          } else if (this.ruleForm2.expireType == 1) {
            this.ruleForm2.expireType = "按天";
            this.ruleForm2.expireDayNum = this.ruleForm2.expireDayNum;
          } else if (this.ruleForm2.expireType == 2) {
            this.ruleForm2.expireType = "按时间";
            this.ruleForm2.time = [this.ruleForm2.startTime, this.ruleForm2.endTime];
          } else {
          }
          if (this.ruleForm2.integralSwitch == true) {
            this.ruleForm2.integralSwitch = true;
            // console.log(e.integral, "e.integral")
            if (this.ruleForm2.integral == 1) {
              this.integralValue = "消费1元送1个积分";
            } else if (this.ruleForm2.integral == 10) {
              this.integralValue = "消费1元送10个积分";
            } else if (this.ruleForm2.integral == 100) {
              this.integralValue = "消费1元送100个积分";
            } else {
              this.integralValue = "";
            }
          } else {
            this.ruleForm2.integralSwitch = false;
          }
          if (this.ruleForm2.highSwitch == true) {
            this.ruleForm2.highSwitch = true;
            // this.ruleForm2.cumulateConsumeCount = this.ruleForm2.cumulateConsumeCount
            // this.ruleForm2.cumulateConsumeMoney = this.ruleForm2.cumulateConsumeMoney
            // this.ruleForm2.cumulateScore = this.ruleForm2.cumulateScore
            this.memberLevel = this.ruleForm2.cardLevel;
          } else {
            this.ruleForm2.highSwitch = false;
          }
        }
      });
    },
    createMemberCard() {
      console.log(this.ruleForm2, this.fromColor, "添加编辑会员卡");
      // return
      this.$refs.ruleForm2.validate((valid) => {
        if (!valid) {
          this.$notify({
            title: "提示",
            message: "请输入相应信息",
            type: "warning",
            duration: 1000,
          });
          return;
        }
        var expireType,
          isDefault,
          openReceiveAfterPay,
          openReceiveInYSC,
          isAliCard,
          isWxCard,
          integralSwitch,
          fullConsume,
          integral,
          cardLevel,
          cumulateConsumeCount,
          cumulateConsumeMoney,
          cumulateScore,
          highSwitch,
          isEnable;
        if (this.ruleForm2.isEnable == "启用") {
          isEnable = 1;
        } else {
          isEnable = 0;
        }
        if (this.ruleForm2.integralSwitch == true) {
          integralSwitch = 1;
          fullConsume = 1;
          if (this.integralValue == 1 || this.integralValue == "消费1元送1个积分") {
            integral = 1;
          } else if (
            this.integralValue == 10 ||
            this.integralValue == "消费1元送10个积分"
          ) {
            integral = 10;
          } else if (
            this.integralValue == 100 ||
            this.integralValue == "消费1元送100个积分"
          ) {
            integral = 100;
          }
        } else {
          integralSwitch = 0;
          fullConsume = null;
          integral = null;
        }
        if (this.ruleForm2.highSwitch == true) {
          highSwitch = 1;
          cardLevel = this.memberLevel;
          cumulateConsumeCount = this.ruleForm2.cumulateConsumeCount;
          cumulateConsumeMoney = this.ruleForm2.cumulateConsumeMoney;
          cumulateScore = this.ruleForm2.cumulateScore;
        } else {
          highSwitch = 0;
          cardLevel = null;
          cumulateConsumeCount = null;
          cumulateConsumeMoney = null;
          cumulateScore = null;
          this.memberLevel = "";
        }
        if (this.ruleForm2.expireType == "按天") {
          //0 永久  1天数  2 日期范围
          expireType = 1;
        } else if (this.ruleForm2.expireType == "永久") {
          expireType = 0;
          this.ruleForm2.expireDayNum = "";
        } else if (this.ruleForm2.expireType == "按时间") {
          expireType = 2;
          this.ruleForm2.expireDayNum = "";
        }
        if (this.ruleForm2.isDefault == "开启") {
          isDefault = 1;
        } else {
          isDefault = 0;
        }
        if (this.ruleForm2.openReceiveAfterPay == true) {
          openReceiveAfterPay = 1;
        } else {
          openReceiveAfterPay = 0;
        }
        if (this.ruleForm2.openReceiveInYSC == true) {
          openReceiveInYSC = 1;
        } else {
          openReceiveInYSC = 0;
        }
        if (this.ruleForm2.isAliCard == true) {
          isAliCard = 1;
        } else {
          isAliCard = 0;
        }
        // if (this.ruleForm2.quickApplySwitch == true) {
        //   quickApplySwitch = 1;
        // } else {
        //   quickApplySwitch = 0;
        // }
        if (this.ruleForm2.isWxCard == true) {
          isWxCard = 1;
        } else {
          isWxCard = 0;
        }
        var discount = 0;
        discount = (this.ruleForm2.discount / 10).toFixed(2);

        // if (this.ruleForm2.highSwitch == true) {
        //   console.log(1)
        //   if (this.ruleForm2.cumulateConsumeCount >= 0 || this.ruleForm2.cumulateConsumeMoney >= 0 || this.ruleForm2.cumulateScore >= 0) {
        //     console.log(3)
        //   } else {
        //     console.log(2)
        //     this.$message.error("请输入会员等级相关信息")
        //     return
        //   }
        // }
        console.log(this.integralValue, "this.integralValue");
        if (this.$route.query.style == "update") {
          console.log(this.ruleForm2, "update");
          updateMemberCard({
            shopMemberCardId: this.ruleForm2.id,
            cardName: this.ruleForm2.cardName,
            discount: discount,
            servicePhone: this.ruleForm2.servicePhone,
            price: this.ruleForm2.price,
            originalPrice: this.ruleForm2.originalPrice,
            cardSlogan: this.ruleForm2.cardSlogan,
            useNotice: this.ruleForm2.useNotice,
            expireType: expireType,
            expireDayNum: this.ruleForm2.expireDayNum,
            startTime: expireType == 2 ? this.ruleForm2.time[0] : "",
            endTime: expireType == 2 ? this.ruleForm2.time[1] : "",
            openReceiveAfterPay: openReceiveAfterPay,
            openReceiveInYSC: openReceiveInYSC,
            shopMemberCardColorId: this.fromColor.id,
            isDefault: isDefault,
            isAliCard: isAliCard,
            isWxCard: isWxCard,
            integral: integral,
            fullConsume: fullConsume,
            integralSwitch: integralSwitch,
            cardLevel: cardLevel,
            cumulateConsumeCount: cumulateConsumeCount,
            cumulateConsumeMoney: cumulateConsumeMoney,
            cumulateScore: cumulateScore,
            highSwitch: highSwitch,
            quickApplySwitch: this.ruleForm2.quickApplySwitch,
            isEnable: isEnable,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.goback();
              this.ruleForm2 = {};
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
          return;
        }
        createMemberCard({
          cardName: this.ruleForm2.cardName,
          discount: discount,
          servicePhone: this.ruleForm2.servicePhone,
          price: this.ruleForm2.price,
          originalPrice: this.ruleForm2.originalPrice,
          cardSlogan: this.ruleForm2.cardSlogan,
          useNotice: this.ruleForm2.useNotice,
          expireType: expireType,
          expireDayNum: this.ruleForm2.expireDayNum,
          startTime: this.ruleForm2.time[0] || "",
          endTime: this.ruleForm2.time[1] || "",
          openReceiveAfterPay: openReceiveAfterPay,
          openReceiveInYSC: openReceiveInYSC,
          shopMemberCardColorId: this.fromColor.id,
          isDefault: isDefault,
          isAliCard: isAliCard,
          isWxCard: isWxCard,
          integral: integral,
          fullConsume: fullConsume,
          integralSwitch: integralSwitch,
          cardLevel: cardLevel,
          cumulateConsumeCount: cumulateConsumeCount,
          cumulateConsumeMoney: cumulateConsumeMoney,
          cumulateScore: cumulateScore,
          highSwitch: highSwitch,
          quickApplySwitch: this.ruleForm2.quickApplySwitch,
          isEnable: isEnable,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success(res.msg);
            this.goback();
            this.ruleForm2 = {};
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mt10 {
  margin-top: 10px;
}
.addVipcard {
  padding: 20px;
  box-sizing: border-box;
  .addVip {
    .vipCard {
      position: relative;
      .card-bg {
        top: 50%;
        position: absolute;
        left: -2%;
        transform: translateY(-49%);
        height: 97px;
        width: 272px;
      }
      .name {
        color: #c3445e;
        font-size: 14px;
        position: absolute;
        top: 9px;
        left: 25px;
        font-weight: 1000;
      }
      .welcome {
        font-size: 12px;
        color: #fff;
        position: absolute;
        top: 32px;
        left: 25px;
      }
      .time {
        font-size: 12px;
        color: rgb(250, 250, 250);
        position: absolute;
        top: 87px;
        left: 27px;
      }
      .discount {
        text-align: right;
        width: 72px;
        font-size: 12px;
        color: rgb(250, 250, 250);
        position: absolute;
        top: 33px;
        left: 132px;
      }
      .changeColor {
        height: 123px;
        width: 196px;
        margin-left: 15px;
        border-radius: 10px;
        box-shadow: 2px 2px 8px #888888;
      }
    }
    .addVip-content {
      font-size: 14px;
      margin-top: 24px;
      font-size: 14px;
      color: #606266;
      .pcikColor {
        height: 30px;
        width: 85px;
        border: 1px solid #bbb;
        margin-left: 55px;
      }
      .input1 {
        width: 780px;
      }
      .input2 {
        width: 190px;
      }
    }
  }
}
.square {
  height: 17px;
  width: 17px;
  display: inline-block;
}
.square:not(:first-child) {
  margin-left: 11px;
}
.small {
  height: 20px;
  width: 75px;
}
.row {
  display: flex;
  flex-direction: row;
}
.center {
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.alignCenter {
  display: flex;
  align-items: center;
}
</style>
